
import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  useEffect(() => {
    // Set the correct title
    document.title = "GruasZaragoza24";
    
    // Function to remove Emergent badge
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.style.display = 'none';
        badge.remove();
      }
      // Also remove any links to emergent
      document.querySelectorAll('a[href*="emergent.sh"]').forEach(el => {
        el.style.display = 'none';
        el.remove();
      });
    };
    
    // Run immediately
    removeBadge();
    
    // Run again after a short delay (in case badge is injected later)
    const timer1 = setTimeout(removeBadge, 100);
    const timer2 = setTimeout(removeBadge, 500);
    const timer3 = setTimeout(removeBadge, 1000);
    const timer4 = setTimeout(removeBadge, 2000);
    
    // Also set up an observer to catch any dynamically added badges
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      observer.disconnect();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
